import { render, staticRenderFns } from "./UserValidSettingUpdate.vue?vue&type=template&id=12e7c878&"
import script from "./UserValidSettingUpdate.vue?vue&type=script&lang=js&"
export * from "./UserValidSettingUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports